<template>
<div id="addaccessories">
    <el-form ref="partsAddDto" :model="partsAddDto" :rules="zcrules" label-width="80px" class="zcyhtk">
        <el-form-item label="配件名称：" prop="partsName">
            <el-input v-model="partsAddDto.partsName"></el-input>
        </el-form-item>
           <el-form-item label="配件分类：" prop="partCateId">
          <!-- <el-cascader :options="fjfltableData" :show-all-levels="false" :clearable="true" v-model="cpflejcateId" :props="cascaderProps" @change="erjiszcheack">
              <template #default="{ data }">
              <span>{{ data.cateName }} <span>{{ data.cateTypeName }}</span></span>
            </template>
           </el-cascader> -->
           <el-select v-model="partsAddDto.partCateId" clearable placeholder="请选择配件分类">
                <el-option
                  v-for="item in fjfltableData"
                  :key="item.cateId"
                  :label="item.cateName"
                  :value="item.cateId">
                </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="配件描述：">
            <el-input v-model="partsAddDto.partsDesc"></el-input>
        </el-form-item>
        <el-form-item label="配件详情：">
          <quill-editor ref="quillEditor"  v-model="partsAddDto.detail" :options="editorOptions" class="sztpdxs" ></quill-editor>
           </el-form-item>
        <el-form-item label="配件适用范围：">
            <el-input v-model="partsAddDto.partsRange"></el-input>
        </el-form-item>
        <el-form-item label="商品描述：">
            <el-input v-model="partsAddDto.specSku"></el-input>
        </el-form-item>
        <el-form-item label="规格状态：">
            <el-radio-group v-model="partsAddDto.status">
              <el-radio label="0">上架</el-radio>
              <el-radio label="1">下架</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="单位：" prop="unit">
            <el-input v-model="partsAddDto.unit"></el-input>
        </el-form-item>
        <el-form-item label="备注信息：">
            <el-input v-model="partsAddDto.remark"></el-input>
        </el-form-item>
        <el-form-item label="配件主图：">
          <el-upload
              class="upload-demo"
              action="#"
              ref="upload"
              :limit="1"
              :http-request="handleRequest"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-exceed="handleExceed"
              list-type="picture-card"
              :file-list="fileList"
          >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">图片尺寸建议宽690px*高250px</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="有无视频：">
               <el-switch
               @change="handspscchChange(partsAddDto.videoStatus)"
                v-model="partsAddDto.videoStatus"
                active-color="#13ce66"
                inactive-color="#DBDBDB"
                active-value="1"
                inactive-value="0">
              </el-switch>
        </el-form-item>
        <el-form-item label="视频上传：" v-if="partsAddDto.videoStatus == '1'">
          <el-upload
          v-if="!spscUploaded"
              class="upload-demo"
              action="#"
              ref="upload"
              :http-request="handleRequest"
              :before-upload="spsceforeUpload"
              :on-success="spscandleSuccess"
              :on-error="spscandleError"
              :on-exceed="spscandleExceed"
              list-type="picture-card"
              :file-list="spscileList"
          >
          <i class="el-icon-plus"></i>
          </el-upload>
          <div v-else>
            <div class="videocontainer">
              <img src="../../assets/dell.png" alt="" class="videobutton" @click="scspandleDelete()">
              <video :src="videoUrl" controls  class="listvideo"></video>
            </div>
          </div>
        </el-form-item>
        <div class="gglblid">
          <el-form-item label="规格：">
          <el-select v-model="specificationCate" value-key="specificationCateId"  @change="valuetimecheack">
            <el-option
              v-for="item in gglxdata"
              :key="item.index"
              :label="item.cateName"
              :value="item.specificationCateId">
            </el-option>
        </el-select>
          <el-select v-model="specName" clearable value-key="specificationsId" @change="ggmccheack">
            <el-option
              v-for="item in ggmcData"
              :key="item.index"
              :label="item.specName"
              :value="item"
            />
            </el-select>
            <!-- 添加按钮 -->
            <el-button type="primary" v-if="specificationsCreateDtoList.length < 5" plain @click="addDataObject">添加规格</el-button>
            <!-- <el-button type="primary" plain @click="addDataObject">添加规格</el-button> -->
          </el-form-item>
          <el-form-item class="gglblidlist" v-if="specificationsCreateDtoList.length>0">
              <!-- 数据列表 -->
            <div v-for="(dataItem, index) in specificationsCreateDtoList" :key="index" style="margin-bottom: 20px;">
                  <p>{{ dataItem.specName }}</p>
                  <!-- 小数据：子数组和下拉框 -->
                  <div class="xszdys">
                    <div v-for="(subItem, subIndex) in dataItem.specificationsValueDtos" :key="subIndex" class="zszdysxg">
                    <el-select
                        v-model="subItem.specificationValue" placeholder="请选择" clearable value-key="id" @change="handleSubItemChange($event,subIndex,index,subItem)">
                        <el-option
                        v-for="(option, optionIndex) in dataItem.specificationzsz"
                        :key="optionIndex"
                        :label="option.specificationValue"
                        :value="option"
                        />
                    </el-select>
                    <i title="删除"  class="el-icon-alishanchu"  style="color: #d81e06;font-size: 18px;cursor: pointer;"  @click=zddscdelete(index,subIndex,subItem)></i>
                  </div>
                  <el-button type="primary" plain style="margin-left: 20px;height: 40px;" @click="addSubArray(index)">添加明细</el-button>
                </div>
            </div>
            <el-button v-if="specificationsCreateDtoList.length>0" type="primary" @click="scgglbSubmit">确定</el-button>
          </el-form-item>
          </div>
          <div class="tableform" v-if="tableData.length>0" style="margin-left: 113px;margin-bottom: 50px;">
              <el-table
                  :data="tableData"
                  border
                  stripe
                  :cell-style="{'text-align':'center'}"
                  :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
                  style="width: 100%"
                  :key="tableKey"
                  >
                  <el-table-column
                      v-for="(item, index) in specificationsCreateDtoList"
                      :key="index"
                      :label="item.specName"
                    >
                    <template slot-scope="scope">
                        <div v-for="(subItem, subIndex) in scope.row.productSpecDtos" :key="subIndex">
                          <span v-if="subItem.specName === item.specName">{{ subItem.specificationValue }}</span>
                        </div>
                      </template>
                    </el-table-column>
                  <el-table-column
                      prop="stock"
                      label="库存"
                      >
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.stock"
                          placeholder="请输入库存"
                        />
                      </template>
                  </el-table-column>
                  <el-table-column
                      prop="price"
                      label="售价"
                      >
                      <template slot-scope="scope">
                        <el-input
                          type="number"
                          v-model="scope.row.price"
                          placeholder="请输入售价"
                        />
                      </template>
                  </el-table-column>
                  <el-table-column
                      prop="specSku"
                      label="型号"
                      >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.specSku"
                          placeholder="请输入型号"
                        />
                      </template>
                  </el-table-column>
                  <el-table-column
                      prop="status"
                      label="是否上架"
                      >
                      <template slot-scope="scope">
                        <el-switch
                          v-model="scope.row.status"
                          active-color="#13ce66"
                          inactive-color="#DBDBDB"
                          active-value="0"
                          inactive-value="1">
                        </el-switch>
                      </template>
                  </el-table-column>
                  <el-table-column
                      label="图片"
                      >
                      <template slot-scope="scope">
                        <el-upload
                          action="#"
                            v-if="!scope.row.isUploaded"
                            :http-request="handleRequest"
                            :on-success="ggtpleSuccess(scope.$index, scope.row)" 
                            :limit="1"
                            :before-upload="ggtpUpload" 
                            list-type="picture-card"
                            :file-list="scope.row.ggtpfileList"
                        >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <div v-else>
                        <div class="image-container">
                          <img src="../../assets/dell.png" alt="" class="close-button" @click="handleDelete(scope.row)">
                          <img 
                            :src="scope.row.fileUrl" 
                            alt="上传的照片" 
                            class="listimage"
                            @click="handlePreview(scope.row.fileUrl)"
                          />
                        </div>
                      </div>
                      </template>
                  </el-table-column>
              </el-table>
          </div>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('partsAddDto')">提交</el-button>
          <el-button @click="fhreturn">取消</el-button>
        </el-form-item>
    </el-form>
    <!-- 大图查看弹窗 -->
    <el-dialog
      v-model="dialogVisible" title="查看大图" :visible.sync="dialogVisible" width="40%">
      <img :src="previewImage" alt="大图" style="width: 100%;" />
    </el-dialog>
</div>
</template>
<script>
    import ipConfig from "../../utils/ipconfig";
   // 引入 Quill 编辑器和 Vue 适配器
   import { quillEditor } from 'vue-quill-editor'
   import 'quill/dist/quill.core.css'
   import 'quill/dist/quill.snow.css'
   import Compressor from 'compressorjs';
   export default {
    components: {
      quillEditor
    },
   name:'addaccessories',
   data(){
    return{
        partsAddDto:{
            partsName:null,
            partsDesc:null,
            partCateId:null,
            partsRange:null,
            remark:null,
            specSku:null,
            unit:null,
            status:'0',
            detail:null,
            videoStatus:'0',
            videoFileUrl:null,
            fileMetaDtos:[],
            partsVariantsAddDtos:[]
        },
        spscUploaded:false,
        videoUrl:null,
        spscileList: [],
        fjfltableData: [],
        ggmcData:[],
        ggszData:[],
        fileList: [],

        gglxdata:[],
        ggmcinfo:{},
        categoryPageDto:{
          cateType:1,
          parentCateId:null,
          cateName:null,
        },
        editorOptions: {
          theme: 'snow', // 选择主题
          placeholder: '请输入文本...', // 默认提示文字
          modules: {
            toolbar: [
              [{ header: '1'}, { header: '2'}, { font: [] }],
              [{ list: 'ordered'}, { list: 'bullet' }],
              ['bold', 'italic', 'underline'],
              [{ align: [] }],
              ['link'],
              ['blockquote'],
              ['image'],
            ]
          }
        },
        zcrules: {
            partsName: [
              { required: true, message: '请输入配件名称', trigger: 'blur' },
            ],
            partCateId: [
              { required: true, message: '请选择配件分类', trigger: 'blur' },
            ],
            unit: [
              { required: true, message: '请输入单位', trigger: 'blur' },
            ],
         },
        specificationCate:null,
        specName: '', 
        specificationsCreateDtoList: [], 
        tableData: [],
        tableKey: 0, // 用于触发 table 渲染更新
        dialogVisible: false,
        previewImage: '', // 用于存储点击图片后展示的大图 URL
    }
   },
   created(){
      this.dataService()
      this.cpflgetlist(this.categoryPageDto)
      // this.partsAddDto.partCateId = this.$route.query.partsCateId
   },
   mounted(){
    this.initializeQuill();
   },
   methods:{
    initializeQuill() {
          // 获取 Quill 实例
          const quill = this.$refs.quillEditor.quill;
          const toolbar = quill.getModule('toolbar');
          // 修改图片上传按钮的行为
          toolbar.addHandler('image', this.customImageUpload);
        },
        // 自定义图片上传方法
        async customImageUpload() {
          // 创建文件选择框
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.click();
          input.onchange = async (e) => {
            const file = e.target.files[0];
            if (!file) return;
            // 调用后台接口上传图片
            const formData = new FormData();
            formData.append('file', file);
            this.$api.uploadPackage({
            file:file
            }).then((res) => {
                if (res.data.code == 200) {
                  let oriFileUrl = res.data.data.oriFileUrl
                  this.$message.success(res.data.message)
                  let imageUrl = ''
                  if (oriFileUrl.startsWith('https')) {
                    imageUrl = oriFileUrl
                  } else {
                    imageUrl = ipConfig.baseUrl + oriFileUrl
                  }
                  this.insertImageIntoEditor(imageUrl);
                } else {
                    this.$message.error(res.data.message)
                }
            })
          };
        },
        // 将图片 URL 插入到编辑器中
      insertImageIntoEditor(imageUrl) {
        const quill = this.$refs.quillEditor.quill;
        const range = quill.getSelection(); // 获取当前光标位置
        quill.insertEmbed(range.index, 'image', imageUrl); // 插入图片
      },
    cpflgetlist(categoryPageDto) {
          this.$api.cplbbfyqueryList(categoryPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.fjfltableData = res.data.data
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
    dataService() {
        this.$api.specificationCate().then((res) => {
              if(res.data.code==200){
                this.gglxdata = res.data.data
              }else{
                this.$message.error(res.data.message)
              }
        })
    },
    handleRequest(request) {
         const formData = new FormData();
         formData.append('file', request.file); // 这里的 'file' 是后端接收文件的字段名
         this.$api.uploadPackage({
            file:request.file
         }).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  request.onSuccess(res.data.data); // 当请求成功时，调用 onSuccess
                } else {
                    this.$message.error(res.data.message)
                }
            })
    },
    handleExceed(files, fileList) {
        this.$message.warning('已超出只能上传一张图片的限制，请先移除现有图片再上传新图片。');
    },
    // 删除图片
    handleRemove(file, fileList) {
        this.fileList=[]
        this.partsAddDto.fileMetaDtos=[]
    },
    // 图片上传失败的回调函数
    handleError(error, file, fileList) {
        this.$message.error('图片上传失败');
    },
    // // 上传前的处理函数
    // beforeUpload(file) {
    //    // 限制文件类型
    //    const isImage = file.type.startsWith('image/');
    //      const isVideo = file.type === 'video/mp4';
    //      if (!isImage && !isVideo) {
    //      this.$message.error('只能上传图片或 MP4 格式的视频文件');
    //      return false;
    //      }
    //      // 限制文件大小
    //      const maxSize = 30 * 1024 * 1024; // 100MB
    //      if (file.size > maxSize) {
    //      this.$message.error('文件大小不能超过 30MB');
    //      return false;
    //      }
    //      return true;
    // },
    beforeUpload(file) {
          return new Promise((resolve, reject) => {
            if (file.type.startsWith('video/mp4')) {
              resolve();
            } else if (file.type.startsWith('image')) {
              new Compressor(file, {
                quality: 0.85,        // 压缩质量，范围 0 - 1
                maxWidth: 800,       // 图片最大宽度
                maxHeight: 800,      // 图片最大高度
                mimeType: 'image/jpeg', // 强制压缩为 JPEG 格式
                success: (compressedFile) => {
                  file.compressed = compressedFile;
                  resolve();
                },
                error: (err) => {
                  console.error('图片压缩失败', err);
                  reject('图片压缩失败');
                },
              });
            } else {
              reject('只支持上传图片和 MP4 格式视频');
            }
          });
        },
   // 图片上传成功的回调函数
   handleSuccess(response, file, fileList) {
      // // 这里可以处理成功后的逻辑，例如展示上传后的图片
      this.fileList.push({
          name: file.name,
          url: response.oriFileUrl
      });
      this.partsAddDto.fileMetaDtos.push({
            fileId:response.fileId,
            imageType:null,
            imageUrl:response.oriFileUrl,
            positionSort:null,
            thumbnailUrl:null,
      });
   },
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tableData.forEach(element => {
            element.productSpecDtoList = element.productSpecDtos;
            delete element.productSpecDtos;      
          });
          this.partsAddDto.partsVariantsAddDtos.push(...this.tableData);
          this.$api.tjpjaddParts(this.partsAddDto).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  this.$router.push({
                      path: "accessories",
                  });
                } else {
                    this.$message.error(res.data.message)
                }
            })
        } 
      });
    },
    handspscchChange(row) {
        if (row == 0) {
        this.partsAddDto.videoFileUrl = null;
        this.videoUrl = null;
        this.spscUploaded = false;
        }
    },
    scspandleDelete() {
      this.partsAddDto.videoFileUrl = null;
      this.videoUrl = null;
      this.spscUploaded = false;
    },
    spscandleExceed(files, fileList) {
           this.$message.warning('已超出只能上传一张图片的限制，请先移除现有图片再上传新图片。');
       },
     // 视频失败的回调函数
     spscandleError(error, file, fileList) {
           this.$message.error('图片上传失败');
       },
    spsceforeUpload(file) {
      const isVideo = file.type.startsWith('video/');
        if (!isVideo) {
          this.$message.error('只能上传视频文件');
          return false;
        }
        const maxSize = 100 * 1024 * 1024; // 100MB
        const isSizeValid = file.size <= maxSize;
        if (!isSizeValid) {
          this.$message.error('视频文件大小不能超过 100MB');
        }
        return isSizeValid; 
    },
    spscandleSuccess(response, file, fileList) {
      this.partsAddDto.videoFileUrl = response.oriFileUrl
      if (response.oriFileUrl.startsWith('https')) {
          this.videoUrl = response.oriFileUrl;
        } else {
          this.videoUrl = ipConfig.baseUrl+response.oriFileUrl;
        }
      if (this.partsAddDto.videoFileUrl) {
        this.spscUploaded = true
      }
    },
    valuetimecheack(value){
      this.getlist(value)
    },
    getlist(value) {
        this.$api.gglbyationsPage({
          pageNum:1,
          pageSize:20,
          specificationCateId:value
        })
        .then((res) => {
          if(res.data.code==200){
            if (res.data.data.records) {
              this.ggmcData = res.data.data.records
            }
            }else{
              this.$message.error(res.data.message)
            }
        })
      },
    ggmccheack(value){
      let isPush = true
      if (this.specificationsCreateDtoList) {
        this.specificationsCreateDtoList.forEach(element => {
          if (element.specName == value.specName) {
            this.$message.warning('已选过'+value.specName);
            this.specName = '', 
            isPush = false
          }
      });
      }
      if (isPush) {
        this.specName = value.specName
        this.specificationsId = value.specificationsId
        this.wlspecificationsValueDtos = value.specificationValues
      }
    },
      // 添加数据对象
    addDataObject() {
      if (this.specName) {
          const newDataObject = {
          specName: this.specName,
          specificationsId: this.specificationsId,
          specificationsValueDtos: [
            {
              specificationValue:null,
              specificationValueId:null,
            }
          ],
          specificationzsz: this.wlspecificationsValueDtos
        };
        this.specificationsCreateDtoList.push(newDataObject);
        this.specName = '';
        this.specificationsId = '';
      }
    },
    scgglbSubmit(){
      this.$api.specificationList({
        goodsId:null,
        goodsType: 1,
        specificationsCreateDtoList:this.specificationsCreateDtoList
      }).then((res) => {
            if (res.data.code == 200) {
            let date = res.data.data
            date.forEach(element => {
              element.status = element.status.toString()
              element.price = '0.0'
              element.ggtpfileList = []
              element.isUploaded = false
              element.fileUrl = null
            });
            this.tableData = date
            } else {
                this.$message.error(res.data.message)
            }
        })
    },
    handleSubItemChange(value,subIndex,index,subItem) {
      let isPush = true
      if (this.specificationsCreateDtoList) {
        this.specificationsCreateDtoList.forEach(element => {
        element.specificationsValueDtos.forEach(item => {
          if (item.specificationValue == value.specificationValue) {
            this.$message.warning('已选过该数值');
            subItem.specificationValue = '', 
            isPush = false
          }
        });
      });
      }
      if (isPush) {
        this.specificationsCreateDtoList[index].specificationsValueDtos[subIndex].specificationValue = value.specificationValue
        this.specificationsCreateDtoList[index].specificationsValueDtos[subIndex].specificationValueId = value.id
      }
    },
    addSubArray(index) {
      let data = {
        specificationValue:null,
        specificationValueId:null,
      }
      this.specificationsCreateDtoList[index].specificationsValueDtos.push(data);
    },
    zddscdelete(index,subIndex,subItem){
      if (this.tableData.length>0) {
        let indexList = []
        this.tableData.forEach((element,index) => {
          element.productSpecDtos.forEach(item => {
            if (item.specificationValue == subItem.specificationValue) {
              indexList.push(index)
          }
          });
        });
        console.log();
        
        indexList.forEach((item,index) => {
            this.tableData.splice((item-index), 1)
        });
        this.specificationsCreateDtoList[index].specificationsValueDtos.splice(subIndex, 1);
        this.specificationsCreateDtoList = this.specificationsCreateDtoList.filter(item => item.specificationsValueDtos.length !== 0);
        this.tableKey++;
      }else{
        this.specificationsCreateDtoList[index].specificationsValueDtos.splice(subIndex, 1);
        this.specificationsCreateDtoList = this.specificationsCreateDtoList.filter(item => item.specificationsValueDtos.length !== 0);
      }
    },
  // 上传成功的处理方法
  ggtpleSuccess(index, row) {
      return (response, file, fileList) => {
        this.tableData[index].mainImage = response.oriFileUrl
        this.tableData[index].fileId = response.fileId
        if (response.oriFileUrl.startsWith('https')) {
          this.tableData[index].fileUrl =  response.oriFileUrl
        } else {
          this.tableData[index].fileUrl =  ipConfig.baseUrl+response.oriFileUrl
        }
        row.isUploaded = true; // 设置上传标志，表示文件已上传
        // this.partsAddDto.partsVariantsAddDtos[index].ggtpfileList.push({
        //   name: file.name,
        //   url: ipConfig.baseUrl+response.oriFileUrl
        // });
      };
    },
    // // 在文件上传之前进行的操作
    // ggtpUpload(file) {
    //     // 限制文件类型
    //       const isImage = file.type.startsWith('image/');
    //       const isVideo = file.type === 'video/mp4';
    //       if (!isImage && !isVideo) {
    //       this.$message.error('只能上传图片或 MP4 格式的视频文件');
    //       return false;
    //       }
    //       // 限制文件大小
    //       const maxSize = 30 * 1024 * 1024; // 100MB
    //       if (file.size > maxSize) {
    //       this.$message.error('文件大小不能超过 30MB');
    //       return false;
    //       }
    //       return true;
    // },
    ggtpUpload(file) {
          return new Promise((resolve, reject) => {
            if (file.type.startsWith('video/mp4')) {
              resolve();
            } else if (file.type.startsWith('image')) {
              new Compressor(file, {
                quality: 0.85,        // 压缩质量，范围 0 - 1
                maxWidth: 800,       // 图片最大宽度
                maxHeight: 800,      // 图片最大高度
                mimeType: 'image/jpeg', // 强制压缩为 JPEG 格式
                success: (compressedFile) => {
                  file.compressed = compressedFile;
                  resolve();
                },
                error: (err) => {
                  console.error('图片压缩失败', err);
                  reject('图片压缩失败');
                },
              });
            } else {
              reject('只支持上传图片和 MP4 格式视频');
            }
          });
        },
   // 删除上传的图片
    handleDelete(row) {
      if (row.fileId) {
            this.$api.scwjremoveFile({
              fileId:row.fileId
            }).then((res) => {
                if (res.data.code == 200) {
                  row.fileUrl = '';
                  row.isUploaded = false;
                  row.mainImage = ''
                  row.fileId = ''
                  this.$message.success(res.data.message)
                } else {
                    this.$message.error(res.data.message)
                }
            })
          }else{
            row.fileUrl = '';
            row.isUploaded = false;
            row.mainImage = ''
            row.fileId = ''
          }
  },
  // 点击图片查看大图
  handlePreview(imageUrl) {
    this.previewImage = imageUrl;
    this.dialogVisible = true;
  },
    fhreturn(){
          this.$router.push({
              path: "accessories",
          });
      },
   }
   }
</script>
<style scoped>
#addaccessories {
 width: 100%;
 height: 100%;
 overflow-y: auto;
 background-color: #fff;
 padding:0 0 0 30px;
 box-sizing: border-box;
}
.zcyhtk /deep/ .el-form-item__label {
    width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
    margin-left: 120px !important;
}
.zdjsddddd /deep/ .el-input{
  width: 100%;
}
.zdjsddddd /deep/ .el-select{
  width: 20%;
}
.el-button--text {
  margin-left: 10px;
}
.el-cascader-panel > div:nth-child(1) > div > ul > li > .el-checkbox {
  display: none !important;
}
.zdjsdd{
  border-top: 1px solid#DCDCDC;
  margin-bottom: 20px;
  padding-top: 20px;
 }
 .has-border{
   border-top: 1px solid#DCDCDC;
   margin-top: 40px;
 }
 .yxzdgg /deep/ .el-form-item__content{
  display: flex;
 }
 .yxzdgg div{
  margin-right: 20px;
 }
 .submit-button{
  margin-left: 50px;
 }
 .videocontainer {
    position: relative;
    display: inline-block;
  }
  .listvideo {
    max-width: 200px; 
    cursor: pointer;
    display: block;
    z-index: 999;
  }
  .videobutton {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    display: inline-block;
    z-index: 9999; 
  }
  .sztpdxs /deep/ img {
    max-width: 20% !important; 
    height: auto;
  }
  .gglblid{
    padding-top: 20px;
    border-top: #DCDCDC 1px solid;
  }
  .gglblidlist /deep/  .el-form-item__content{
    margin-left: 116px !important;
    padding: 20px;
    background-color: #F9F9F9;
  }
  .gglblidlist p{
    margin: 0;
  }
  .image-container {
    position: relative;
    display: inline-block;
    padding-top: 10px;
    width: 120px;
    height: 100px;
  }
  .close-button {
    position: absolute;
    top: 3px;
    right: 4px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
  .listimage {
    max-width: 100px; 
    max-height: 100px; 
    cursor: pointer;
  }
  .xszdys{
    display: flex;
    flex-wrap: wrap;
    margin-left: -20px;
  }
  .zszdysxg{
    margin-left: 20px; 
    width: 252px;
    margin-bottom: 10px;
  }
  .el-upload__tip{
    font-size: 14px;
    color: #0889FD;
  }
</style>


// WEBPACK FOOTER //
// src/components/accessorieslist/addaccessories.vue